import axiosClient from "axios-client";

export const fetchData = async (endpoint) => {
    try {
        const data = await axiosClient.get(endpoint);

        return data?.data?.data;
    } catch (err) {
        console.error(err);

        return [];
    }
};
